import { buildPayloadDispatcher } from 'types/payload.constants';

/**
 *
 *
 *

 // service + api-url

 const payloadTemplate = buildPayloadTemplate("userInfo", getUserService);

 const Wrapped = withSecureServices(Controller, {
   loadingAction: [payloadTemplate]

 });
 <WithSecureController />




 */
export const buildPayloadTemplate =
  (payloadAction, service) =>
  (...args) =>
  async (dispatch, getState) => {
    const finalPayloadAction =
      payloadAction ?? buildPayloadDispatcher(payloadAction);
    try {
      dispatch(finalPayloadAction(null, true, null));
      const c = await service(...args);

      dispatch(payloadAction(c, false, null));

      return c;
    } catch (err) {
      dispatch(payloadAction(null, false, err));

      throw err;
    }
  };
